import { jsx as _jsx } from "react/jsx-runtime";
import radiantGreenUrl from '../../../assets/gems/radiant_green.svg?inline';
export function RadiantGreen({ ...props }) {
    return _jsx("img", { ...props, src: radiantGreenUrl, alt: 'RadiantGreenImage' });
}
